export const leadingChangeTemplate = [
    {
        questionDimension: 'Leading Change',
        type: 'Matrix',
        questionLabel: 'Leading Change',
        options: [
            {
                label: "Strongly disagree",
                value: "1"
            },
            {
                label: "Somewhat disagree",
                value: "2"
            },
            {
                label: "Neither agree nor disagree",
                value: "3"
            },
            {
                label: "Somewhat agree",
                value: "4"
            },
            {
                label: "Strongly agree",
                value: "5"
            }
        ],
        question: '',
        matrixQuestions: [{
            text: `I understand the purpose and outcomes of the ERP project.`, value: '', isSelected: false
        },
        {
            text: `Project leaders and executives are doing a good job of keeping us informed about the ERP project.`, value: '', isSelected: false

        },
        {
            text: `Project leaders and executives truly value my perspective on the ERP project.`, value: '', isSelected: false

        },
        {
            text: `I understand how successful ERP project implementation will lead to achieving organizational goals.`, value: '', isSelected: false

        }]
    }
]

